import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// base urls
import { nmFoundationBaseUrl } from '../../../../../utils/unsecuredLinks';

export default () => {
  return (
    <SectionContainer
      id='sustainability-impact-communities-see-how-we-invest'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            See how we invest in <WidowBlock>our future</WidowBlock>
          </Typography>
          <Typography
            align='center'
            disableBottomPadding>
            Find out more about the{' '}
            <Link
              id='sustainability-impact-communities-see-how-we-invest-link'
              variant='primaryDeemphasize'
              linkUrl={`${nmFoundationBaseUrl}/`}
              isInternalPdf // getting the target blank functionality but still referring for SEO
            >
              Northwestern Mutual Foundation
            </Link>.
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};
